import { render, staticRenderFns } from "./allTree.vue?vue&type=template&id=15f97ac8&scoped=true"
import script from "./allTree.vue?vue&type=script&lang=js"
export * from "./allTree.vue?vue&type=script&lang=js"
import style0 from "./allTree.vue?vue&type=style&index=0&id=15f97ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f97ac8",
  null
  
)

export default component.exports